import { withStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';

export const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
      font: '400 1rem "Nunito"'
    },
  }))(MuiDialogContent);